import React, { SVGProps } from "react";

const SvgRoof10 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof023 dims 1">
      <path
        fill="#b4c5d3"
        d="M135.907 225.145v35.701l185.047-106.955v-35.702L135.907 225.145z"
      />
      <path
        fill="#fff"
        d="M135.907 224.934v35.767L30.349 199.899v-73.78l105.558 98.815z"
      />
      <path
        fill="#2e99d2"
        d="M331.977 112.026 136.274 225.278 19.636 116.09 215.634 3l116.343 109.026z"
      />
      <g fill="#6d9faf">
        <path d="M76.258 185.997v10.648l-8.853-5.099v-10.649l8.853 5.1zM87.102 192.258v10.648l-8.853-5.099v-10.649l8.853 5.1zM76.258 198.75v10.648l-8.853-5.099V193.65l8.853 5.1zM87.102 205.011v10.648l-8.853-5.099v-10.649l8.853 5.1z" />
      </g>
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M30.349 126.119v73.78l105.558 60.947 185.047-106.955v-35.702"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M135.907 224.934v35.912"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M136.275 225.278 19.636 116.09 215.634 3l116.343 109.026-195.702 113.252z"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m110.76 275.225 18.313-10.585M5.463 214.56l18.269-10.625M10.05 212.051l104.885 60.427" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m161.661 276.565-18.312-10.584M348.032 169.093l-18.269-10.625M343.292 166.672 157.657 273.72" />
      </g>
      <text
        transform="translate(257.085 229.028)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(51.324 254.995)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M343.513 162.702v7.572M157.225 270.105v7.572M115.289 268.936v7.572M9.897 208.164v7.572"
      />
      <path
        d="M127.576 178.232a120.807 120.807 0 0 1-.856 19.585 91.44 91.44 0 0 1-3.295 15.416M39.644 127.62l92.881 53.496M130.653 176.584l-6.557 3.786M126.854 211.638l-6.557 3.786"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <text
        transform="translate(129.116 202.98)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"P"}
      </text>
    </g>
  </svg>
);

export default SvgRoof10;
